const rules = {
	user: {
		static: [
			"drawer-service-items:view",
		],
	},

	supervisor: {
		static: [
			"drawer-service-items:view",
			"dashboard:view",
			"tickets-manager:showall",
		],
	},

	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"drawer-service-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"update-version"
		],
	},
};

export default rules;
